import React, { useState, useEffect } from "react";
import { NavLink, Outlet, Link, useLocation } from "react-router-dom";
import { Home as HomeIcon, BarChart3 as BarChart3Icon,
  LayoutDashboard, Users, Layers, MapPin, ShoppingBag, Wallet, Star, ShieldAlert,
  MessageCircle, Bell, Ticket, Settings, Palette, Award, FileText, Database, Upload,
  UserCog, LineChart, Gift, Percent, CreditCard, ArrowLeft, LayoutTemplate, Shapes,
  Images, Menu as MenuIcon, ArrowLeftRight, BookOpen, LifeBuoy, HelpCircle, X, ListChecks, SlidersHorizontal, ClipboardList, Flame, MapPinned, Languages as LanguagesIcon,
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const NAV = [
  { section: "Overview", items: [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
    { to: "/admin/reports", label: "Reports", icon: LineChart, testid: "admin-nav-reports" },
    { to: "/admin/audit-logs", label: "Audit logs", icon: FileText, testid: "admin-nav-audit" },
  ]},
  { section: "Users", items: [
    { to: "/admin/entities/users", label: "Users", icon: Users, testid: "admin-nav-users" },
    { to: "/admin/entities/team_members", label: "Team members", icon: UserCog, testid: "admin-nav-team-members" },
    { to: "/admin/roles", label: "Roles & permissions", icon: ShieldAlert, testid: "admin-nav-roles" },
  ]},
  { section: "Providers", items: [
    { to: "/admin/entities/provider_profiles", label: "Providers", icon: Award, testid: "admin-nav-providers" },
    { to: "/admin/entities/verification_requests", label: "Verifications", icon: ShieldAlert, testid: "admin-nav-verifications" },
    { to: "/admin/entities/licenses", label: "Licenses", icon: FileText, testid: "admin-nav-licenses" },
    { to: "/admin/entities/insurance_policies", label: "Insurance", icon: FileText, testid: "admin-nav-insurance" },
  ]},
  { section: "Marketplace", items: [
    { to: "/admin/entities/services", label: "Services", icon: Layers, testid: "admin-nav-services" },
    { to: "/admin/entities/categories", label: "Categories", icon: Layers, testid: "admin-nav-categories" },
    { to: "/admin/entities/locations", label: "Locations", icon: MapPin, testid: "admin-nav-locations" },
    { to: "/admin/entities/project_requests", label: "Project requests", icon: MessageCircle, testid: "admin-nav-requests" },
    { to: "/admin/entities/proposals", label: "Proposals", icon: MessageCircle, testid: "admin-nav-proposals" },
    { to: "/admin/service-requests", label: "Service requests", icon: ClipboardList, testid: "admin-nav-service-requests" },
    { to: "/admin/questionnaires", label: "Request questionnaires", icon: ListChecks, testid: "admin-nav-questionnaires" },
    { to: "/admin/matching", label: "Matching settings", icon: SlidersHorizontal, testid: "admin-nav-matching" },
    { to: "/admin/entities/deals", label: "Deals", icon: Percent, testid: "admin-nav-deals" },
    { to: "/admin/hot-deals", label: "Hot deals", icon: Flame, testid: "admin-nav-hot-deals" },
  ]},
  { section: "Data", items: [
    { to: "/admin/data-center", label: "Data Center", icon: Database, testid: "admin-nav-data-center" },
  ]},
  { section: "Website", items: [
    { to: "/admin/website", label: "Pages Manager", icon: LayoutTemplate, testid: "admin-nav-website" },
    { to: "/admin/website/homepage", label: "Homepage Settings", icon: HomeIcon, testid: "admin-nav-homepage-settings" },
    { to: "/admin/analytics/homepage", label: "Homepage Performance", icon: BarChart3Icon, testid: "admin-nav-homepage-analytics" },
    { to: "/admin/templates", label: "Templates", icon: Shapes, testid: "admin-nav-templates" },
    { to: "/admin/media", label: "Media library", icon: Images, testid: "admin-nav-media" },
    { to: "/admin/navigation", label: "Navigation", icon: MenuIcon, testid: "admin-nav-navigation" },
    { to: "/admin/redirects", label: "Redirects", icon: ArrowLeftRight, testid: "admin-nav-redirects" },
    { to: "/admin/translations", label: "Spanish translations", icon: LanguagesIcon, testid: "admin-nav-translations" },
    { to: "/admin/blog", label: "Blog", icon: BookOpen, testid: "admin-nav-blog" },
    { to: "/admin/help", label: "Help center", icon: LifeBuoy, testid: "admin-nav-help" },
    { to: "/admin/faqs", label: "FAQs", icon: HelpCircle, testid: "admin-nav-faqs" },
  ]},
  { section: "Transactions", items: [
    { to: "/admin/entities/bookings", label: "Bookings", icon: ShoppingBag, testid: "admin-nav-bookings" },
    { to: "/admin/job-verification", label: "Job verification", icon: MapPinned, testid: "admin-nav-job-verification" },
    { to: "/admin/entities/orders", label: "Digital orders", icon: ShoppingBag, testid: "admin-nav-orders" },
    { to: "/admin/entities/payments", label: "Payments", icon: Wallet, testid: "admin-nav-payments" },
    { to: "/admin/entities/payouts", label: "Payouts", icon: Wallet, testid: "admin-nav-payouts" },
  ]},
  { section: "Trust & safety", items: [
    { to: "/admin/entities/reviews", label: "Reviews", icon: Star, testid: "admin-nav-reviews" },
    { to: "/admin/disputes", label: "Disputes", icon: ShieldAlert, testid: "admin-nav-disputes" },
    { to: "/admin/entities/conversations", label: "Conversations", icon: MessageCircle, testid: "admin-nav-conversations" },
  ]},
  { section: "Monetization", items: [
    { to: "/admin/entities/plan_tiers", label: "Plans", icon: CreditCard, testid: "admin-nav-plans" },
    { to: "/admin/entities/subscriptions", label: "Subscriptions", icon: CreditCard, testid: "admin-nav-subscriptions" },
    { to: "/admin/entities/promo_codes", label: "Promo codes", icon: Percent, testid: "admin-nav-promos" },
    { to: "/admin/entities/gift_cards", label: "Gift cards", icon: Gift, testid: "admin-nav-giftcards" },
    { to: "/admin/entities/credit_ledger", label: "Credits", icon: Wallet, testid: "admin-nav-credits" },
    { to: "/admin/entities/referral_attributions", label: "Referrals", icon: Users, testid: "admin-nav-referrals" },
    { to: "/admin/entities/featured_placements", label: "Featured", icon: Star, testid: "admin-nav-featured" },
  ]},
  { section: "Support", items: [
    { to: "/admin/entities/support_tickets", label: "Support tickets", icon: Ticket, testid: "admin-nav-support" },
    { to: "/admin/notifications", label: "Notifications", icon: Bell, testid: "admin-nav-notifications" },
  ]},
  { section: "System", items: [
    { to: "/admin/brand", label: "Brand settings", icon: Palette, testid: "admin-nav-brand" },
    { to: "/admin/payments", label: "Payments (Stripe)", icon: CreditCard, testid: "admin-nav-payments-settings" },
    { to: "/admin/settings", label: "Settings", icon: Settings, testid: "admin-nav-settings" },
    { to: "/admin/import", label: "Import CSV", icon: Upload, testid: "admin-nav-import" },
    { to: "/admin/entities/audit_logs", label: "Audit log records", icon: Database, testid: "admin-nav-audit-entity" },
  ]},
];

function NavContent({ onNavigate }) {
  return (
    <>
      <div className="px-5 py-4 border-b border-slate-100 flex items-start justify-between gap-2">
        <div>
          <Link to="/" className="text-xs uppercase tracking-[0.2em] text-[#165a71] font-bold" onClick={onNavigate}>Gulf Coast Work</Link>
          <div className="font-display text-lg text-[#071b22] font-semibold">Admin console</div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-4" data-testid="admin-sidebar">
        {NAV.map((sec) => (
          <div key={sec.section}>
            <div className="px-2 text-[10px] uppercase tracking-[0.2em] font-semibold text-[#252A34]/50 mb-1">{sec.section}</div>
            <ul className="space-y-0.5">
              {sec.items.map((n) => (
                <li key={n.to}>
                  <NavLink
                    to={n.to}
                    end={n.end}
                    onClick={onNavigate}
                    data-testid={n.testid}
                    className={({ isActive }) => `flex items-center gap-2 rounded-lg px-3 py-2 text-sm ${isActive ? "bg-[#165a71]/10 text-[#071b22] font-medium" : "text-[#252A34]/80 hover:bg-slate-50"}`}
                  >
                    <n.icon className="h-4 w-4" />
                    <span className="truncate">{n.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
      <div className="px-4 py-3 border-t border-slate-100 text-xs text-[#252A34]/60">
        <Link to="/" onClick={onNavigate} className="inline-flex items-center gap-1 hover:text-[#165a71]" data-testid="admin-exit">
          <ArrowLeft className="h-3 w-3" /> Back to site
        </Link>
      </div>
    </>
  );
}

export default function AdminLayout() {
  const { user } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Auto-close the drawer on route change (mobile UX).
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Lock body scroll while the drawer is open.
  useEffect(() => {
    if (mobileOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = prev; };
    }
  }, [mobileOpen]);

  const isStaff = (user?.roles || []).some((r) => ["administrator", "super_administrator", "moderator", "support_agent"].includes(r));
  if (!user) return <div className="p-10 text-[#252A34]">Loading…</div>;
  if (!isStaff) return (
    <div className="p-10 max-w-lg mx-auto">
      <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center">
        <ShieldAlert className="h-6 w-6 mx-auto text-[#165a71]" />
        <div className="font-display text-lg text-[#071b22] font-semibold mt-2">Staff only</div>
        <div className="text-sm text-[#252A34]/70 mt-1">Sign in with an administrator, moderator or support-agent account.</div>
        <Link to="/dashboard" className="mt-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm">← Back to dashboard</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="admin-layout">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex w-64 shrink-0 border-r border-slate-200 bg-white flex-col">
        <NavContent />
      </aside>

      {/* Mobile top bar with hamburger */}
      <div className="lg:hidden fixed top-0 inset-x-0 z-30 bg-white border-b border-slate-200 flex items-center justify-between px-4 h-14" data-testid="admin-mobile-topbar">
        <button
          onClick={() => setMobileOpen(true)}
          className="inline-flex items-center gap-2 rounded-lg p-2 hover:bg-slate-100"
          data-testid="admin-mobile-menu-btn"
          aria-label="Open admin menu"
        >
          <MenuIcon className="h-5 w-5 text-[#071b22]" />
          <span className="font-display font-semibold text-[#071b22] text-sm">Admin</span>
        </button>
        <Link to="/" className="text-xs uppercase tracking-[0.2em] text-[#165a71] font-bold" data-testid="admin-mobile-brand">GCW</Link>
      </div>

      {/* Mobile drawer + overlay */}
      {mobileOpen && (
        <>
          <div
            className="lg:hidden fixed inset-0 z-40 bg-slate-900/50"
            onClick={() => setMobileOpen(false)}
            data-testid="admin-mobile-overlay"
          />
          <aside
            className="lg:hidden fixed inset-y-0 left-0 z-50 w-72 max-w-[85vw] bg-white shadow-2xl flex flex-col"
            data-testid="admin-mobile-drawer"
          >
            <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
              <div className="font-display font-semibold text-[#071b22]">Menu</div>
              <button
                onClick={() => setMobileOpen(false)}
                className="rounded-lg p-1.5 hover:bg-slate-100"
                data-testid="admin-mobile-close"
                aria-label="Close admin menu"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <NavContent onNavigate={() => setMobileOpen(false)} />
          </aside>
        </>
      )}

      <main className="flex-1 min-w-0 pt-14 lg:pt-0 py-4 lg:py-8 px-4 md:px-6 lg:px-10 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
